export default __webpack_public_path__ + "static/white-nr-black-bananatex-bb2d4d42e841bcbcd67ec5252b0203b0.png";